<template>
    <el-dialog :title="title" :visible="showflag" @close="closeDialog" :close-on-click-modal="false" fullscreen>
        <el-row style="width: 100%">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix" style="text-align: center">
                        <span style="font-size: 22px;font-weight: bold">{{report.work_type}}记录表</span>
                    </div>
                    <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                        <div class="el-table__body-wrapper is-scrolling-none">
                            <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                <tbody>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>工程名称：</span></div>
                                        </td>
                                        <td class="el-table__cell" colspan="3">
                                            <div class="cell"><span>{{report.unit_name}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>设备编号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.device_code}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>通道号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.channel_no}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>施工单位：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.construction_unit}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>监测单位：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.monitor_unit}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>开始时间：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.begin_time}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>结束时间：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.end_time}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>单元：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.unit_code}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>作业方式：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.work_type}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>孔号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.hole_code}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>孔序：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.hole_order}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_no}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段长(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_length}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段顶(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_top}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>段底(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.segment_bottom}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>桩号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.pile_no}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>抬动孔号：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.lift_hole_no}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>孔口高程(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.hole_height}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>排序：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.order_index}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>水灰比：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.water_ash}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>砂灰比：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.sand_ash}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压力设定(Mpa)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.pressure_set}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>水泥比重(g/cm3)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.water_mud_proportion}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>砂比重(g/cm3)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.sand_proportion}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>循环方式：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.circle_type}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>涌水压力(Mpa)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.water_pressure}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>地下水位(m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.groundwater_level}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>注浆量(L)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.grout_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>累计注灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.ash_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>单位注灰量(kg/m)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.ash_volume_unit}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>砂量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.sand_volume}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>余浆量(L)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.grout_volume_throw}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>弃灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.ash_volume_throw}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>管容(L)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.piping_volume}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>管道占灰量(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.piping_ash_volume}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>外加剂1(Kg)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.material1_total}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>外加剂2(Kg):</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.material2_total}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>防伪特征码：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.security_code}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>纯灌时间：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.grout_duration_str}}</span></div>
                                        </td>
                                    </tr>
                                    <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==2 || report.work_type_int ==3">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>透水率(Lu)：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.permeable_rate}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>防伪特征码：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.security_code}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>纯灌时间：</span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span>{{report.grout_duration_str}}</span></div>
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span></span></div>
                                        </td>
                                        <td class="el-table__cell">
                                            <div class="cell"><span></span></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row style="width: 100%; height: 455px; margin-top: 20px;margin-left: 0;margin-right: 0;" :gutter="20">
            <el-col :span="12" style="padding-left: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                        <span>采样数据</span>
                    </div>
                    <el-table :data="samplingList" border stripe height="370">
                        <el-table-column prop="sampling_time_str" label="时间" sortable="custom"></el-table-column>
                        <el-table-column prop="flow" label="流量(L/Min)" sortable="custom"></el-table-column>
                        <el-table-column prop="pressure" label="压力(Mpa)" sortable="custom"></el-table-column>
                        <el-table-column prop="density" label="密度(g/cm3)" sortable="custom"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量(L)" sortable="custom" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量(kg)" sortable="custom" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率(Lu)" sortable="custom" v-if="report.work_type_int ==2 || report.work_type_int ==3"></el-table-column>
                        <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
                    </el-table>
                </el-card>
            </el-col>
            <el-col :span="12" style="padding-right: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                        <span>数据统计图</span>
                    </div>
                    <el-radio-group v-model="echarts_show" size="small" @input="changeEcharts">
                        <el-radio-button label="1">流量</el-radio-button>
                        <el-radio-button label="2">压力</el-radio-button>
                        <el-radio-button label="3">密度</el-radio-button>
                        <el-radio-button label="4">抬动</el-radio-button>
                    </el-radio-group>
                    <div class="echarts1" id="myChart1">
                        
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row style="width: 100%; height: 390px; margin-top: 20px;margin-left: 0;margin-right: 0;" :gutter="20">
            <el-col :span="12" style="padding-left: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                        <span>错误信息</span>
                    </div>
                    <template v-for="msg in msgList">
                        <el-alert :title="msg" type="error" :closable="false" :key="msg" style="margin-top: 10px"></el-alert>
                    </template>
                </el-card>
            </el-col>
            <el-col :span="12" style="padding-right: 0;height:100%">
                <el-card class="box-card" style="height: 100%">
                    <div slot="header" class="clearfix">
                        <span>数据处理</span>
                    </div>
                    <el-form ref="formValidate" :model="model" :rules="rules" label-width="200px">
                        <el-form-item label="设备编号：" prop="device_no">
                            <el-input v-model="model.device_no" style="width: 220px" ></el-input>
                        </el-form-item>
                        <el-form-item label="孔号：" prop="hole_code">
                            <el-input v-model="model.hole_code" style="width: 220px"></el-input>
                        </el-form-item>
                        <el-form-item label="段号：" prop="segment_no">
                            <el-input v-model="model.segment_no" style="width: 220px"></el-input>
                        </el-form-item>
                        <el-form-item label="作业方式：" prop="work_type_int">
                            <el-select clearable v-model="model.work_type_int" placeholder="请选择" style="width: 220px">
                                <el-option v-for="item in enuObj('work_type_int')" :key="'work_type_int'+item.key" :label="item.title" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="复灌编号：" prop="fg_index" v-if="model.work_type_int==4">
                            <el-input v-model="model.fg_index" style="width: 220px"></el-input>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">关 闭</el-button>
            <el-button type="danger" @click="discardData" size="medium">丢弃数据</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById, saveModel } from '@/api/common'
import {dealPreviewReport} from "@/api/workreport";

// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')

export default {
    name: 'abnormalworkReportInfo',
    mixins: [editutil],
    data() {
        return {
            msgList: [],
            report: {
                work_type_int: 1
            },
            samplingList: [],
            echarts_show: 0,
            line1: [],
            line2: [],
            line3: [],
            line4: [],
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '8%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    name:'',
                    type: 'value'
                },
                series: [
                    {
                        name: '',
                        type: 'line',
                        areaStyle: {},
                        data: []
                    }
                ]
            },
            getObj:{
                url:'/api/admin/workreport/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['work_type_int'],
            model: {
                report_id: '',
                device_no: '',
                hole_code: '',
                segment_no: '',
                work_type_int: '',
                repeat: 1,
                fg_index: '',
            },
            rules: {
                device_no: [
                    {required: true, message: '设备编号不能为空', trigger: 'blur'},
                ],
                hole_code: [
                    {required: true, message: '孔号不能为空', trigger: 'blur'}
                ],
                segment_no: [
                    {required: true, message: '段号不能为空', trigger: 'blur'}
                ],
                work_type_int: [
                    {required: true, message: '作业方式不能为空', trigger: 'blur'}
                ]
            },
        };
    },
    methods: {
        loadOtherData() {
            //加载其他内容， 可重写
            this.msgList = []
            this.report = {work_type_int: 1}
            this.samplingList = []
            this.echarts_show = 0
            this.line1 = []
            this.line2 = []
            this.line3 = []
            this.line4 = []
            this.option.yAxis.name = ''
            this.option.series[0].name = ''
            this.option.series[0].data = []
            setTimeout(() => {
                var myChart1 = echarts.init(document.getElementById("myChart1"));
                myChart1.setOption(this.option);
            }, 3000);
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.report = res.data.workReport;
                        this.samplingList = res.data.samplingList
                        this.msgList = res.data.msgList
                        this.line1 = res.data.line1
                        this.line2 = res.data.line2
                        this.line3 = res.data.line3
                        this.line4 = res.data.line4
                        this.option.xAxis.data = res.data.xAxis
                        this.echarts_show = '1'
                        this.changeEcharts('1')
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        changeEcharts(e){
            if(e =='1'){
                this.option.yAxis.name = '流量(L/Min)'
                this.option.series[0].name = '流量(L/Min)'
                this.option.series[0].data = this.line1
            }else if(e=='2'){
                this.option.yAxis.name = '压力(Mpa)'
                this.option.series[0].name = '压力(Mpa)'
                this.option.series[0].data = this.line2
            }else if(e=='3'){
                this.option.yAxis.name = '密度(g/cm3)'
                this.option.series[0].name = '密度(g/cm3)'
                this.option.series[0].data = this.line3
            }else if(e=='4'){
                this.option.yAxis.name = '抬动(um)'
                this.option.series[0].name = '抬动(um)'
                this.option.series[0].data = this.line4
            }
            var myChart1 = echarts.init(document.getElementById("myChart1"));
            myChart1.setOption(this.option);
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/workreport/dealAbNormal'
                    }
                    this.model.repeat = 1
                    this.model.report_id = this.report.id
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs(res.msg);
                            this.$emit("on-save-ok",{});
                        }else if(res.code ==2){
                            this.$confirm('该灌浆孔的该段号的报告已经导入，是否要覆盖？', '提示', {
                                confirmButtonText: '确定覆盖',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                //确认
                                this.model.repeat = 2
                                this.model.report_id = this.report.id
                                config["data"] = this.model;
                                saveModel(config).then(res=>{
                                    if(res.code===1){
                                        this.$msgs(res.msg);
                                        this.$emit("on-save-ok",{});
                                    }else{
                                        this.$msg(res.msg)
                                    }
                                }).catch();
                            }).catch(() => {
                                //取消
                            });
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        discardData(){
            dealPreviewReport(this.report.id, -1).then(res=>{
                if(res.code == 1){
                    this.$msgs(res.msg);
                    this.$emit("on-save-ok",{});
                }else{
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: res.msg
                    });
                }
            })
        },
    }
};
</script>
<style lang="less" scoped>
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
    .echarts1{
        width: 100%;
        height: 340px;
        margin-top: 0;
    }
</style>